export default "/images/HDAW_STEP_5.png";